var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape11 = function SvgShape11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.003 19.004c25.127-25.128 65.866-25.128 90.994 0 25.127 25.127 25.127 65.866 0 90.994l-20.999 20.999c-25.127 25.127-65.867 25.127-90.994 0-25.128-25.128-25.128-65.867 0-90.995z",
    opacity: 0.1
  })));
};
export default SvgShape11;